import { Component, computed, HostBinding, input } from '@angular/core';

export interface StepProgressBarStep {
  label?: string;
}

export enum StepProgressBarThemeEnum {
  DIM,
  DIMMER,
}

@Component({
  selector: 'spx-step-progress-bar',
  templateUrl: './step-progress-bar.component.html',
  styleUrls: ['./step-progress-bar.component.scss'],
  imports: [],
})
export class StepProgressBarComponent {
  public currentIndex = input<number>(0);
  public steps = input.required<StepProgressBarStep[]>();
  public displayOnlyCurrentStatus = input<boolean>(false);
  public highlightLastStep = input<boolean>(true);
  public theme = input<StepProgressBarThemeEnum>(StepProgressBarThemeEnum.DIM);
  public hasHeaders = computed(() => this.steps().some((step) => !!step.label));
  public isCurrentLabelValid = computed(() => {
    if (!this.displayOnlyCurrentStatus()) {
      return true;
    }

    const step = this.steps()[this.currentIndex()];
    if (!step?.label) {
      throw new Error('spx-step-progress-bar: displayOnlyCurrentStatus=true needs the current step to have a label set');
    }

    return true;
  });

  @HostBinding('class.dimmer')
  protected get isDimmer(): boolean {
    return this.theme() === StepProgressBarThemeEnum.DIMMER;
  }
}
